import Services from '@/utils/services';
import Mgr from '@/utils/SecurityService';
import signalr from '@/utils/signalr'

let mgr = new Mgr();

const state = {
    userId: null,
    username: '',
    fullName: '',
    unitId: null,
    manageUnitIds: null,
    unitName: null,
    privileges: [],
    isAuthenticated: false,
    isAdmin: false,
    isBTCUser: false,
    isTopLevelUnit: false,
    currentUnit: ''
};

const actions = {
    loadIdentity(context) {
        return new Promise((resolve, reject) => {
            mgr.getUser().then(user => {
                if (user != null) {
                    context.commit("setIdentity", user.profile);
                    context.dispatch('initializeSettings').then(() => {
                        resolve(true);
                    }).catch(() => {
                        resolve(false);
                    });
                    //mgr.monitorSession();

                    signalr.start();
                } else {
                    resolve(false);
                }
            }).catch(() => {
                resolve(false)
            });
        });

        //var accessToken = Services.getAccessToken();
        //if (accessToken) {
        //    context.commit("setIdentity", accessToken);
        //    context.dispatch('initializeSettings');
        //}
    },
    authenticate(context, { username, password }) {
        return Services.login(username, password).done(function (accessToken) {
            context.commit("setIdentity", accessToken);
            context.dispatch('initializeSettings');
        });
    },
    checkIdentity(context, identity) {
        if (identity) {
            if (new Date(identity['expires']) <= new Date() && identity.refresh_token) {
                Services.refreshToken(identity.refresh_token).done(function (accessToken) {
                    context.commit("setIdentity", accessToken);
                });
            } else {
                context.commit("setIdentity", identity);
            }
        }
    },
    deauthenticate(context) {
        mgr.signOut();

        //Services.logout();
        //context.commit('removeIdentity');
        //return Services.logout().done(function () {
        //    context.commit('removeIdentity');
        //});
    }
};

// mutations
const mutations = {
    setIdentity(state, identity) {
        state.userId = identity.sub;
        state.username = identity.name;
        state.fullName = identity.full_name;
        state.unitId = identity.unit_id;
        state.manageUnitIds = identity.manage_unit_ids ? identity.manage_unit_ids.split(',').map(x => parseInt(x)) : [];
        state.unitName = identity.unit_name;
        state.privileges = identity.privileges.split(',');
        state.isAuthenticated = true;
        state.isAdmin = identity.is_administrator == 'True';
        state.isBTCUser = identity.is_btc_user == 'True';
        state.isTopLevelUnit = identity.is_top_level_unit == 'True';

        state.currentUnit = window.localStorage.getItem(`tsc:${state.username}-currentUnit`);

    },
    removeIdentity(state) {
        state.userId = null;
        state.username = '';
        state.fullName = '';
        state.unitId = null;
        state.manageUnitIds = [];
        state.unitName = null;
        state.privileges = [];
        state.isAuthenticated = false;
        state.isAdmin = false;
        state.isBTCUser = false;
        state.isTopLevelUnit = false;
    },
    setCurrentUnit(state, unit) {
        state.currentUnit = unit;

        window.localStorage.setItem(`tsc:${state.username}-currentUnit`, unit);
    }
};

export default {
    state,
    actions,
    mutations
};
